import React from 'react';

export default function Loader({
  className = '',
  loading = false,
  children = null,
  skeleton = <div className="spinner" />
}) {
  if (!loading) {
    return children;
  }

  return <div className={className}>{skeleton}</div>;
}
